import isString from 'lodash-es/isString';

export namespace SystemLogger {
  enum LogLevel {
    Error = 0,
    Warn = 1,
    Info = 2,
    Debug = 3,
  }

  const level: LogLevel = process.env.NODE_ENV === 'development' ? LogLevel.Debug : LogLevel.Info;

  type LogFunc = (...val: Array<any>) => void;

  function logWithStyle(logFunc: LogFunc, content: any, style: string): void {
    if (isString(content)) {
      return logFunc(`%c${content}`, style);
    }
    return logFunc(content);
  }

  function getLevelStyle(lvl: LogLevel): string {
    switch (lvl) {
      case LogLevel.Error:
        return 'color: #FF1744;';
      case LogLevel.Warn:
        return 'color: #F57C00;';
      case LogLevel.Info:
        return 'color: #2979FF;';
      case LogLevel.Debug:
        return 'color: #757575;';
      default:
        return 'color: #757575;';
    }
  }

  function getLogFunction(lvl: LogLevel, content: any, group: boolean): LogFunc {
    if (group) {
      return console.groupCollapsed;
    }
    switch (lvl) {
      case LogLevel.Error:
        return console.error;
      case LogLevel.Warn:
        return console.warn;
      case LogLevel.Info:
      case LogLevel.Debug:
      default:
        return console.log;
    }
  }

  function log(lvl: LogLevel, content: any, group: boolean = false): void {
    if (level >= lvl) {
      const logFunc = getLogFunction(lvl, content, group);
      switch (lvl) {
        case LogLevel.Error:
          return logFunc(content);
        case LogLevel.Warn:
          return logFunc(content);
        case LogLevel.Info:
        case LogLevel.Debug:
        default:
          return logWithStyle(logFunc, content, getLevelStyle(lvl));
      }
    }
  }

  export function info(content: any): void {
    log(LogLevel.Info, content);
  }

  export function debug(content: any): void {
    log(LogLevel.Debug, content);
  }

  export function debugGroup(name: any, content: Array<any>): void {
    if (level >= LogLevel.Debug) {
      log(LogLevel.Debug, name, true);
      content.forEach(val => debug(val));
      console.groupEnd();
    }
  }

  export function warn(content: any): void {
    log(LogLevel.Warn, content);
  }

  export function warnGroup(name: any, content: Array<any>): void {
    if (level >= LogLevel.Warn) {
      log(LogLevel.Warn, name, true);
      content.forEach(val => warn(val));
      console.groupEnd();
    }
  }

  export function error(content: any): void {
    log(LogLevel.Error, content);
  }
}



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/util/SystemLogger.ts